class Fetch {
	static post(url, payload) {
		const requestBody = new FormData();
		Object.keys(payload).forEach((key) => {
			let value = null;
			switch (typeof payload[key]) {
				case 'object':
					value = JSON.stringify(payload[key]);
					break;
				case 'array':
					value = payload[key].toString();
					break;
				default:
					value = payload[key];
			}
			requestBody.append(key, value);
		});

		return new Promise((resolve) => {
			fetch(url, {
				method: 'POST',
				body: requestBody,
				cache: 'no-cache',
			})
			.then(this.handleFetchErrors)
			.then(response => response.json())
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				console.error(error);
				resolve(false);
			});
		});
	}

	static get(url) {
		return new Promise((resolve) => {
			fetch(url, {
				method: 'GET',
				cache: 'no-cache',
			})
			.then(this.handleFetchErrors)
			.then(response => response.json())
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				console.error(error);
				resolve(false);
			});
		});
	}

	handleFetchErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}
}

export default Fetch;